/* B&M – Avis clientes (sections/bm-manual-reviews.liquid).
   - « Voir plus » : affiche 5 avis de plus à chaque clic, puis disparaît.
   - Photos : agrandissement plein écran (<dialog>), flèches et touches ← →, Échap / clic à côté pour fermer.
     Navigation limitée au groupe de la photo cliquée (vignettes du haut, ou photos d'un même avis). */
(function () {
  var STEP = 5;

  function init(root) {
    if (!root || root.dataset.bmrReady) return;
    root.dataset.bmrReady = '1';

    /* ---------- Voir plus ---------- */
    var more = root.querySelector('[data-bmr-more]');
    if (more) {
      more.addEventListener('click', function () {
        var hidden = root.querySelectorAll('[data-bmr-review][hidden]');
        var first = null;
        for (var i = 0; i < hidden.length && i < STEP; i++) {
          hidden[i].hidden = false;
          if (!first) first = hidden[i];
        }
        if (hidden.length <= STEP) more.parentNode.hidden = true;
        if (first) first.focus({ preventScroll: true });
      });
    }

    /* ---------- Agrandissement ---------- */
    var dialog = root.querySelector('[data-bmr-lightbox]');
    if (!dialog) return;
    var img = dialog.querySelector('[data-bmr-lightbox-img]');
    var prev = dialog.querySelector('[data-bmr-prev]');
    var next = dialog.querySelector('[data-bmr-next]');
    var count = dialog.querySelector('[data-bmr-count]');
    var group = [];
    var current = 0;
    var opener = null;

    function show(index) {
      current = (index + group.length) % group.length;
      var btn = group[current];
      img.src = btn.getAttribute('data-full');
      img.alt = btn.getAttribute('data-alt') || '';
      var many = group.length > 1;
      prev.hidden = !many;
      next.hidden = !many;
      count.textContent = many ? current + 1 + ' / ' + group.length : '';
    }

    function open(btn) {
      var gallery = btn.closest('[data-bmr-gallery]');
      group = Array.prototype.slice.call(gallery.querySelectorAll('[data-bmr-photo]'));
      opener = btn;
      show(group.indexOf(btn));
      document.documentElement.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      dialog.querySelector('[data-bmr-close]').focus();
    }

    function close() {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        onClosed();
      }
    }

    function onClosed() {
      document.documentElement.style.overflow = '';
      if (opener) opener.focus();
    }

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-bmr-photo]');
      if (btn && root.contains(btn)) open(btn);
    });

    dialog.addEventListener('close', onClosed);
    dialog.querySelector('[data-bmr-close]').addEventListener('click', close);
    prev.addEventListener('click', function () { show(current - 1); });
    next.addEventListener('click', function () { show(current + 1); });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('keydown', function (event) {
      if (group.length < 2) return;
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bmr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-bmr]'));
  });

  /* Éditeur : afficher un avis masqué (après le 5e) quand on sélectionne son bloc. */
  document.addEventListener('shopify:block:select', function (event) {
    if (event.target.matches && event.target.matches('[data-bmr-review][hidden]')) {
      event.target.hidden = false;
    }
  });
})();
